import constants from "../config/constants";

const $inject = ['$q', '$injector', 'dataSourceService'];

const authInterceptor = function ($q, $injector, dataSourceService) {
  let factory = {};
  factory.request = request;
  factory.responseError = responseError;

  function request(config) {
    if (dataSourceService.dataSource === constants.DATA_SOURCES.ODATA) {
      let authService = $injector.get('authService');
      let accessToken = authService.getAccessToken();

      if (accessToken) {
        config.headers.Authorization = 'Bearer ' + accessToken;
      }
    }

    return config;
  }

  function responseError(rejection) {
    if (rejection.status === 401
        && dataSourceService.dataSource === constants.DATA_SOURCES.ODATA
        && !rejection.config._retryWith401Refresh) {

      if (window.auth0Client) {
        return $q.when(window.auth0Client.getTokenSilently({ cacheMode: 'off' }))
          .then(function (newToken) {
            let oauthRaw = localStorage.getItem('oauth');
            if (oauthRaw) {
              let oauth = JSON.parse(oauthRaw);
              oauth.access_token = newToken;
              localStorage.setItem('oauth', JSON.stringify(oauth));
            }

            let $http = $injector.get('$http');
            rejection.config.headers.Authorization = 'Bearer ' + newToken;
            rejection.config._retryWith401Refresh = true;
            return $http(rejection.config);
          })
          .catch(function () {
            let authService = $injector.get('authService');
            authService.logout();
            return $q.reject(rejection);
          });
      }

      let authService = $injector.get('authService');
      authService.logout();
      return $q.reject(rejection);
    }

    return $q.reject(rejection);
  }

  return factory;
};

authInterceptor.$inject = $inject;

export default authInterceptor;



// WEBPACK FOOTER //
// ./src/factories/authInterceptor.js